import React, {useContext, useEffect, useRef, useState} from "react";
import {useLocation} from "react-router-dom";
// configuration
import Config from "../../config";
// components & context
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ExternalLink, Link} from "../controls/";
import HeaderSearch from "./HeaderSearch";
import Menu from "./Menu";
import {ScrollContext} from "../../context/ScrollContext";
import {ShopContext} from "../../context/ShopContext"
import {FavouritesContext} from "../../context/FavouritesContext"
// styling and icons
import "./Header.scss";
import "./Header.Button.scss";
import Images from "../../images";
import {faShoppingCart, faHeart, faSearch, faCommentDots, faBars} from "@fortawesome/free-solid-svg-icons";

// links
const links = {
  primary: [
    Config.links.howItWorks,
    Config.links.events,
    Config.links.reports,
    Config.links.ideas
  ],
  secondary: [
    Config.links.about,
    Config.links.contact,
    Config.links.partners,
    Config.links.b2b,
    Config.links.career,
    Config.links.faq,
  ]
};

// the component
function Header() {
  // context
  const scrollContext = useContext(ScrollContext);
  const shop = useContext(ShopContext);
  const favourites = useContext(FavouritesContext);
  // reference to the header
  const refHeader = useRef();
  // state
  const [searchOpen, setSearchOpen] = useState(false); 
  const [menuOpen, setMenuOpen] = useState(false);

  // handle scrolling
  const handleScroll = () => {
    if(refHeader.current) {
      if(scrollContext.getScrollY() > 100) {
        if(refHeader.current.className !== "lean") {
          refHeader.current.className = "lean";
        }
      }
      else {
        if(refHeader.current.className === "lean") {
          refHeader.current.className = "";
        }
      }
    }
    
    //console.log(SC.getScrollY());
  }
  useEffect(() => {
    handleScroll();
    //setSearchOpen(false);
  }, [scrollContext.timestamp, handleScroll])

  
  // render
  const secondaryLinks = links.secondary.map((link, index) => {
    return <div className="item" key={index}><ExternalLink to={link.href}>{link.label}</ExternalLink></div>
  });
  const primaryLinks = links.primary.map((link, index) => {
    return <div className="item" key={index}><ExternalLink to={link.href}>{link.label}</ExternalLink></div>
  });
  
  
  return <>
    <header>
      <div id="v-header-desktop" ref={refHeader}>
        <div id="v-header-desktop-inner">
          <div id="v-header-secondary">
            {secondaryLinks}
          </div>
          <div id="v-header-primary">
            <div id="v-header-primary-left">
              <div id="v-header-primary-logo">
                <HomeLink />
              </div>  
            </div>
            <div id="v-header-primary-right">
              <div id="v-header-primary-links">{primaryLinks}</div>
              <div id="v-header-primary-tools">
                <HeaderButton 
                  visible={true}
                  action={() => setSearchOpen(true)}
                  icon={faSearch} 
                  alt="suchen"
                />
                <HeaderButton 
                  visible={true}
                  action={()=> {
                    if(window.HappyFoxChat) {
                      window.HappyFoxChat.showWidget();
                      window.HappyFoxChat.expandChatbox();
                    }
                    else {
                      console.warn('HappyFox not found')
                      // TODO take any action?
                    }
                  }}
                  icon={faCommentDots}
                  alt="Chat starten"
                />
                <HeaderButton 
                  visible={true}
                  to="/favourites" 
                  icon={faHeart} 
                  count={favourites.count}
                  alt="Favoriten"
                />
                <HeaderButton 
                  visible={true}
                  to="/checkout" 
                  icon={faShoppingCart} 
                  count={shop.cart.count()}
                  alt="Warenkorb"
                />
                <HeaderButton 
                  visible={true}
                  action={() => setMenuOpen(true)}
                  icon={faBars} 
                  alt="Menu anzeigen"
                  className="menu"
                />
              </div>
            </div>
          </div>
          <HeaderSearch 
            isOpen={searchOpen} 
            close={() => {setSearchOpen(false)}}
          />
        </div>
      </div>
    </header>
    <menu><Menu open={menuOpen} onClose={() => setMenuOpen(false)} /></menu>
  </>
  

}

function HomeLink() {
  // if we are in search, the home button leads back to main site, anywhere else, we navigate back to search
  const location = useLocation();
  const homeImage = <img src={Images.logos.appentura.white} alt="Appentura" /> ;

  if(["/", "/search"].includes(location.pathname)) {
    return <a href="/">{homeImage}</a>
  }
  else {
    return <Link to="/">{homeImage}</Link>
  }
}

function HeaderButton({icon, to, action, count, alt, visible, className}) {
  let countBadge = null
  if(count) {
    countBadge = <span className="badge action-ok-secondary">{count}</span>
  }
  let content
  if(to) {
    content = (
      <Link to={to}>
        <FontAwesomeIcon icon={icon} />
        {countBadge}
      </Link>
    )
  }
  if(action) {
    content = (
      <FontAwesomeIcon icon={icon} onClick={action} />
    )
  }
  return (
    <div className={`c-header-button ${className || ""}`} style={{visibility:visible ? "visible":"hidden"}}>
      {content}
    </div>
  )
}

/*
function HeaderMobile() {
  return (
    <div id="v-header-mobile">
      Blalba
    </div>
  )
}
*/

export default Header;
